module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center_5"
  }, [_vm._v("There are night clubs like The Casino, and there is a city called Chicago, and perhaps by now Jake Justus, Helene, and John J. Malone are as real as other people. With these exceptions I’ll have to admit that the characters and events in this book were all dreamed up. If they resemble any actual persons or parties I wouldn’t be surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAIG")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0